export default "__VITE_ASSET__860cdfca__"